import axios from '../../config/axios';

// خدمات API لإدارة خصومات الدورات
const courseDiscountsApi = {
  // الحصول على جميع خصومات الدورات
  getAll: async () => {
    try {
      // للحصول على جميع الخصومات، سنحتاج إلى جلب الدورات أولاً ثم جلب خصومات كل دورة
      const coursesResponse = await axios.get('/api/admin/courses');
      const courses = coursesResponse.data.data || [];
      
      // جلب خصومات كل دورة
      const discountsPromises = courses.map(course => 
        axios.get(`/api/admin/courses/${course.id}/discounts`)
          .then(response => {
            const discounts = response.data.data || [];
            return discounts.map(discount => ({
              ...discount,
              course_name: course.name
            }));
          })
          .catch(() => [])
      );
      
      const discountsArrays = await Promise.all(discountsPromises);
      const allDiscounts = discountsArrays.flat();
      
      return { data: allDiscounts };
    } catch (error) {
      console.error('Error fetching course discounts:', error);
      throw error;
    }
  },

  // الحصول على خصومات دورة محددة
  getByCourse: async (courseId) => {
    try {
      const response = await axios.get(`/api/admin/courses/${courseId}/discounts`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching discounts for course ${courseId}:`, error);
      throw error;
    }
  },

  // إنشاء خصم جديد
  create: async (courseId, data) => {
    try {
      const response = await axios.post(`/api/admin/courses/${courseId}/discounts`, data);
      return response.data;
    } catch (error) {
      console.error('Error creating course discount:', error);
      throw error;
    }
  },

  // تحديث خصم موجود
  update: async (courseId, discountId, data) => {
    try {
      const response = await axios.put(`/api/admin/courses/${courseId}/discounts/${discountId}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating discount ${discountId}:`, error);
      throw error;
    }
  },

  // حذف خصم
  delete: async (courseId, discountId) => {
    try {
      const response = await axios.delete(`/api/admin/courses/${courseId}/discounts/${discountId}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting discount ${discountId}:`, error);
      throw error;
    }
  },

  // تغيير حالة تفعيل الخصم
  toggleStatus: async (courseId, discountId) => {
    try {
      const response = await axios.put(`/api/admin/courses/${courseId}/discounts/${discountId}/toggle-status`);
      return response.data;
    } catch (error) {
      console.error(`Error toggling status for discount ${discountId}:`, error);
      throw error;
    }
  },

  // الحصول على قائمة الدورات
  getCourses: async () => {
    try {
      const response = await axios.get('/api/admin/courses');
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      throw error;
    }
  }
};

export default courseDiscountsApi;
